<template>
  <v-container fluid>
    <h2 class="mb-5">
      {{ prasymasTitle
      }}<el-tooltip
        inline
        :tooltip="`NtrPaslaugos. Nuoma nutraukimas. Anotacija`"
        external
        @activate="
          eventPayload =>
            showAprasymas(
              eventPayload,
              'NtrPaslaugos. Nuoma nutraukimas. Anotacija'
            )
        "
      />
    </h2>
    <div class="paslauga-aprasymas">
      <el-paslauga-aprasymas
        :tooltip="paslaugaAprasymas"
        @close="hideAprasymas"
      />
    </div>
    <el-paslauga-santrauka
      :tooltip="`NtrPaslaugos. Nuoma nutraukimas. Santrauka`"
    />

    <v-card class="pa-0" flat>
      <el-overlay-loading :loading="pageloading" />

      <!-- <el-button
        v-if="showNaujasPrasymas && !showNaujasError"
        :loading="naujasPrasymasLoading"
        @click.native.stop="naujasPrasymas()"
      >
        Pildyti dokumentą
      </el-button> -->

      <el-savitarna-alert v-if="showNaujasError" dense outlined type="error">
        {{ naujasError }}
      </el-savitarna-alert>

      <el-savitarna-alert
        v-if="showWarningPrasymas"
        dense
        outlined
        type="error"
      >
        {{ $t('Jūs neturite nė vienos galiojančios nuomos sutarties.') }}
      </el-savitarna-alert>

      <prasymas-list-rengiami
        :key="rengiamiKey"
        :prasymas-tipas-filter="prasymasTipas"
        @loaded="rengiamiLoaded"
        @edit="editPrasymas"
        @updateList="updateList"
      />

      <prasymas-list-iregistruoti
        :key="iregistruotiKey"
        :prasymas-tipas-filter="prasymasTipas"
        :rengiami-length="rengiamiLength"
        :naujas-prasymas-title="$t('Nutraukti')"
        @loaded="iregistruotiLoaded"
        @naujasPrasymas="naujasPrasymas"
      />
    </v-card>
  </v-container>
</template>

<script>
import prasymasList from '@/mixins/prasymasList'
import userRole from '@/mixins/userRole'
import PrasymasListRengiami from './PrasymasListRengiami'
import PrasymasListIregistruoti from './PrasymasListIregistruoti'

export default {
  name: 'NuomaNutraukimas',
  components: { PrasymasListRengiami, PrasymasListIregistruoti },
  mixins: [prasymasList, userRole],
  data() {
    return {
      search: null,
      prasymas: [],
      searchData: {},
    }
  },
  computed: {
    prasymasKodas() {
      return 'nuoma-nutraukimas'
    },
    showNaujasPrasymas() {
      return (
        this.rengiamiLength == 0 &&
        this.iregistruotiLength == 0 &&
        !this.pageloading
      )
    },
    showWarningPrasymas() {
      return (
        this.rengiamiLength == 0 &&
        this.iregistruotiLength == 0 &&
        !this.pageloading
      )
    },
  },
  created() {
    this.loading = true
  },
  methods: {},
}
</script>
<style lang="scss" scoped></style>
